import { CustomDataTargetType } from "../../types/dto";
import { get, isMockMode, simulateDelay } from "../api";

// targetId is the id of the offering or subscription which you want to get the custom data of
// targetType can be 0 (offering) or 1 (subscription)
export interface GetCustomDataRequest {
	targetId: string;
	targetType: CustomDataTargetType;
}

export const getCustomDatas = (data: GetCustomDataRequest) => {
	if (isMockMode()) {
		const testData = {
			customDatas: [
				{
					id: 123,
					name: "Test Name",
					data: "{}",
					executionPriority: 50,
					isEnabled: true,
				},
			],
		};

		return simulateDelay(50, () => testData);
	}

	return get(
		`CustomData/Get?targetId=${data.targetId}&targetType=${data.targetType}`
	);
};
